import { useFormContext } from 'react-hook-form';
import { HookInput } from '@/components/UI/HookForm/Form/Input';
import { dayjsTz } from '@/features/PrintableGanttChart/helpers';

export function DueDateInput() {
  const { watch } = useFormContext();
  const startDate = watch('startDate');

  const min = startDate ? dayjsTz(startDate).startOf('day').add(1, 'day').format('YYYY-MM-DD') : undefined;

  return <HookInput type='date' label='Due Date' min={min} name='dueDate' id='due-date' />;
}
